import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import VisibilitySensor from 'react-visibility-sensor';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import UserModel from 'models/user';
import Brand from 'models/brand';

import { EventProperties } from '@parkwhiz-js/insights-sdk';
import {
  ACTIVATE_SETUP_PASSWORD_BUTTON_IMPRESSION,
  ACTIVATE_NO_THANKS_BUTTON_IMPRESSION,
  ACTIVATE_CLOSE_BUTTON_IMPRESSION,
  ACTIVATE_SETUP_PASSWORD_BUTTON_CLICK,
  ACTIVATE_NO_THANKS_BUTTON_CLICK,
  ACTIVATE_CLOSE_BUTTON_CLICK,
} from 'lib/analytics/events';

const propTypes = {
  resetPassword: PropTypes.func.isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  dismissActivateAccount: PropTypes.func.isRequired,
  shouldShowActivateAccountModal: PropTypes.bool.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
};

class ResetActiveAccountModal extends Component {
  constructor(props) {
    super(props);

    this.handleModalClose = this.handleModalClose.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.closeButtonVisibilityChange = this.closeButtonVisibilityChange.bind(this);
    this.setPasswordButtonVisibilityChange = this.setPasswordButtonVisibilityChange.bind(this);
    this.noThanksButtonVisibilityChange = this.noThanksButtonVisibilityChange.bind(this);
    this.handleModalNoThanksClose = this.handleModalNoThanksClose.bind(this);
  }

  resetPassword() {
    this.props.trackEvent(ACTIVATE_SETUP_PASSWORD_BUTTON_CLICK);
    this.props.resetPassword({ email: this.props.user.email });
    this.props.dismissActivateAccount();
  }

  handleModalClose() {
    this.props.trackEvent(ACTIVATE_CLOSE_BUTTON_CLICK);
    this.props.dismissActivateAccount();
  }

  handleModalNoThanksClose() {
    this.props.trackEvent(ACTIVATE_NO_THANKS_BUTTON_CLICK);
    this.props.dismissActivateAccount();
  }

  closeButtonVisibilityChange() {
    this.props.trackEvent(ACTIVATE_CLOSE_BUTTON_IMPRESSION);
  }

  setPasswordButtonVisibilityChange() {
    this.props.trackEvent(ACTIVATE_SETUP_PASSWORD_BUTTON_IMPRESSION);
  }

  noThanksButtonVisibilityChange() {
    this.props.trackEvent(ACTIVATE_NO_THANKS_BUTTON_IMPRESSION);
  }

  render() {
    if (!this.props.shouldShowActivateAccountModal) {
      return null;
    }
    const { brand } = this.props;
    this.props.trackEvent({
      ...EventProperties.PAGEVIEW,
      name: 'SignUpAlert',
    });
    const buttonClasses = cx({
      'btn btn-primary btn-block': true,
      'btn-bp': brand.isBestParking,
    });
    return (
      <Modal show className="reset-active-account-modal" onHide={this.handleModalClose}>
        <VisibilitySensor onChange={this.closeButtonVisibilityChange}>
          <div
            type="button"
            onClick={this.handleModalClose}
            className="hidden-xs padding-top-10 padding-right-10 float-right iconified-font iconified-x text-size-18 text-color-blue text-color-hover-blue clickable" data-dismiss="modal"
          />
        </VisibilitySensor>
        <div className="row padding-sm-20 padding-xs-40 text-align-sm-center text-align-xs-left">
          <div className="text-weight-medium text-size-sm-24 text-size-xs-18">Welcome Back!</div>
          <div className="row hidden-xs">
            <div className="col-xs-6 col-xs-offset-3 padding-top-20">
              <img src={brand.logoLightURL} alt={brand.displayName} />
            </div>
          </div>
          <div className="text-weight-book text-size-sm-16 text-size-xs-14 padding-top-20 padding-horizontal-sm-60">
            Hey, we've seen you on ParkWhiz before! Reset your password to get your parking passes on any device at any time, access payment methods, and more.
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-3 padding-top-20">
              <VisibilitySensor onChange={this.setPasswordButtonVisibilityChange}>
                <a className={buttonClasses} onClick={this.resetPassword}>RESET PASSWORD</a>
              </VisibilitySensor>
            </div>
          </div>
          <div className="padding-top-20 padding-bottom-20 text-size-sm-16 text-size-xs-14">
            <Link
              to={{ pathname: '/account/signin' }}
              className="display-block padding-bottom-5"
              title="Log In"
              onClick={this.props.dismissActivateAccount}
            >
              Sign in with my ParkWhiz account instead.
            </Link>
            <VisibilitySensor onChange={this.noThanksButtonVisibilityChange}>
              <a onClick={this.handleModalClose}>No thanks, I'll set up my account later</a>
            </VisibilitySensor>
          </div>
        </div>
        <div className="visible-xs modal-footer text-align-center background-color-light-grey">
          <VisibilitySensor onChange={this.closeButtonVisibilityChange}>
            <div
              type="button"
              onClick={this.handleModalClose}
              className="iconified-font iconified-x text-size-18 text-color-blue text-color-hover-blue clickable"
            />
          </VisibilitySensor>
        </div>
      </Modal>
    );
  }
}

ResetActiveAccountModal.propTypes = propTypes;
ResetActiveAccountModal.defaultPropTypes = defaultProps;
export default ResetActiveAccountModal;